import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0f0bf52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = { class: "selection-bar cm-ui-mb15" }
const _hoisted_3 = { class: "pagination-select-count" }
const _hoisted_4 = { class: "dialog-footer" }

import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { ObjectFormItem } from '@/components/cmForm/types'
import { TableOpt } from '@/components/cmTable/types'
import { ClientInfo, InstalledDetailService, QueryParams } from './installed-detail.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import { TableDataRowState } from '@/services/table-memory-pagination'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import { formatDuration, formatTime, formatTimeStamp } from '@/utils/time'
import dayjs from 'dayjs'
import { useParseTime } from '@/hooks'
import { formatTableEmpty } from '@/utils/format'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'


export default /*#__PURE__*/_defineComponent({
  __name: 'installed-detail',
  props: {
    groupId: { default: -1 },
    softwareKey: { default: '' },
    softwareId: { default: 0 },
    softwareName: { default: '' },
    dateRange: { default: () => [] },
    hasPermission: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const hasPermission = computed(() => props.hasPermission)

const { t, locale } = useI18n()
const injector = useReflectiveInjector([InstalledDetailService])
const service = injector.get(InstalledDetailService)

const tableRef = ref<{ getList: () => void; total?: number } | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)
const visibleRowCount = ref(0)
/** 当前已加载进表格的完整行列表（含滚动累积），与 service.syncVisibleList 共用同一引用 */
const accListRef = ref<TableDataRowState<ClientInfo>[]>([])
/** 最近一次列表请求接口返回的 total，供勾选变更时刷新 memUi（不依赖 tableRef.total 时机） */
const lastSyncedTotal = ref(0)

const data = reactive({
  uninstallType: 0 as 0 | 1,
  uninstallDialogVisible: false,
})

function rangeToStartEnd () {
  const r = props.dateRange?.length === 2
    ? props.dateRange
    : [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
  const [s, e] = useParseTime(r)
  return {
    start_time: s != null ? String(s) : undefined,
    end_time: e != null ? String(e) : undefined,
  }
}

const se = rangeToStartEnd()
const form = reactive<QueryParams>({
  group_id: props.groupId,
  limit: 20,
  page: 1,
  key_word: '',
  soft_id: props.softwareId,
  soft_name: props.softwareName,
  useMemory: false,
  start_time: se.start_time,
  end_time: se.end_time,
  asc: false,
  sort: 'avg_use_count',
})

const memUi = reactive({
  selectCount: 0,
  selectAll: false,
  pageSelectCount: 0,
})

const totalCount = computed(() => tableRef.value?.total ?? 0)

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const filterFormColumns = computed<Partial<ObjectFormItem<any, any>>>(() => {
  void locale.value
  return {}
})

function formatLastActiveRow (row: ClientInfo) {
  const v = row.last_active_time
  if (v == null || v === '') return '--'
  return formatTimeStamp(String(v), 'YYYY-MM-DD HH:mm:ss')
}

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    selection: true,
    columns: [
      ...computerInfoCols(true,false,t,{mac: false}),
      {
        prop: 'soft_version',
        label: t('softwareDispatcher.softVersion'),
        columnOpt: { minWidth: 150 },
        formatter: (row, val) => formatTableEmpty(row, { property: 'soft_version' } as any, val),
      },
      {
        prop: 'install_time',
        label: t('genuineSoftwareUsageColumns.installTime'),
        columnOpt: { minWidth: 180, sortable: 'custom' },
        formatter: (row, _val) => formatTimeStamp(_val, 'YYYY-MM-DD') || '--',
      },
      {
        prop: 'avg_use_count',
        label: t('softwareUsage.avgUseCount'),
        columnOpt: { minWidth: 160, sortable: 'custom' },
        formatter: (row) => row.use_soft_count,
      },
      {
        prop: 'avg_duration',
        label: t('softwareUsage.avgDuration'),
        columnOpt: { minWidth: 160, sortable: 'custom' },
        formatter: (row) => formatDuration(row.duration * 60) || '--',
      },
      {
        prop: 'last_active_time',
        label: t('softwareUsage.lastActiveTime'),
        columnOpt: { minWidth: 170, sortable: 'custom' },
        formatter: (row) => formatLastActiveRow(row),
      },
    ],
    rowKey: 'device_id',
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    path: 'list',
    totalPath: 'total',
    usePagination: false,
    disableScrollLoad: false,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    height: '100%',
  }
})

function buildRequest (raw: Record<string, unknown>): QueryParams {
  return {
    group_id: Number(raw.group_id ?? form.group_id),
    key_word: String(raw.key_word ?? form.key_word ?? ''),
    limit: Number(raw.limit ?? form.limit ?? 20),
    page: Number(raw.page ?? 1),
    soft_id: Number(raw.soft_id ?? form.soft_id ?? 0),
    soft_name: String(raw.soft_name ?? form.soft_name ?? ''),
    useMemory: Boolean(raw.useMemory ?? form.useMemory),
    start_time: raw.start_time != null ? String(raw.start_time) : form.start_time,
    end_time: raw.end_time != null ? String(raw.end_time) : form.end_time,
    asc: typeof raw.asc === 'boolean' ? raw.asc : !!form.asc,
    sort: (raw.sort as string) || form.sort || 'avg_use_count',
  }
}

function updateMemUiAfterListSync () {
  const total = lastSyncedTotal.value
  visibleRowCount.value = accListRef.value.length
  memUi.pageSelectCount = accListRef.value.filter(r => r.$selected).length
  memUi.selectCount = memUi.selectAll ? total : service.getSelectedData().length
}

async function getListApi (raw: Record<string, unknown>) {
  const request = buildRequest(raw)
  const page = request.page
  const isLoadMore = page > 1

  let list: TableDataRowState<ClientInfo>[]
  let total: number

  if (!isLoadMore) {
    accListRef.value = []
  }

  if (request.useMemory && !memUi.selectAll) {
    const all = service.getSelectedData()
    total = all.length
    const start = (page - 1) * request.limit
    list = all.slice(start, start + request.limit) as TableDataRowState<ClientInfo>[]
  } else {
    const res = await service.getListByServer(request)
    total = res.total
    list = res.list as TableDataRowState<ClientInfo>[]
  }

  accListRef.value = isLoadMore ? [...accListRef.value, ...list] : [...list]

  lastSyncedTotal.value = total
  service.syncVisibleList(accListRef.value, total)
  updateMemUiAfterListSync()

  if (isLoadMore) {
    return { list, total }
  }
  return { list: accListRef.value, total }
}

function selRow (slotProps: Record<string, unknown>) {
  return slotProps.row as TableDataRowState<ClientInfo>
}

function onRowCheck (row: TableDataRowState<ClientInfo>) {
  if (memUi.selectAll) return
  service.mergeSelectedData(service.getSelectedData(), row)
  updateMemUiAfterListSync()
}

async function handleSearch (value: string) {
  form.key_word = value
  form.page = 1
  form.useMemory = false
  await refreshList()
}

async function handleQuery () {
  form.page = 1
  await refreshList()
}

async function handleReset () {
  const t0 = rangeToStartEnd()
  form.key_word = ''
  form.start_time = t0.start_time
  form.end_time = t0.end_time
  form.page = 1
  form.useMemory = false
  form.asc = false
  form.sort = 'avg_use_count'
  await refreshList()
}

function getListByMemory () {
  form.useMemory = !form.useMemory
  form.page = 1
  void nextTick(() => void refreshList())
}

function togglePageSelect () {
  if (memUi.selectAll) return
  service.togglePageSelect()
  updateMemUiAfterListSync()
}

function selectAll () {
  form.page = 1
  form.useMemory = false
  memUi.selectAll = true
  service.selectAll()
  void nextTick(() => void refreshList())
}

function selectCancel () {
  form.useMemory = false
  memUi.selectAll = false
  service.cancelSelectAll()
  void nextTick(() => void refreshList())
}

function showUninstallDialog () {
  data.uninstallDialogVisible = true
}

function resetRadio () {
  data.uninstallType = 0
  data.uninstallDialogVisible = false
}

function uninstallSelectedClient () {
  const uninstall_list = service.getSelectedData().map((i) => ({
    device_id: i.device_id,
    soft_hash_key: String(i.soft_hash_key ?? ''),
  }))
  service
    .uninstallSoftware({
      execute_type: 1,
      uninstall_list,
      uninstall_type: data.uninstallType,
      soft_name: props.softwareName,
    })
    .then(() => {
      const n = totalCount.value
      ElMessage.success(t('genuineSoftwareUsage.uninstallSuccessTerminals', { count: n }))
      service.cancelSelectAll()
      memUi.selectAll = false
      void refreshList()
    })
    .catch(() => {
      ElMessage.error(t('softwareUsage.uninstallFailTerminals', { count: totalCount.value }))
      service.cancelSelectAll()
    })
}

function deleteSoftware () {
  const uninstall_list = service.getSelectedData().map((i) => ({
    device_id: i.device_id,
    soft_hash_key: String(i.soft_hash_key ?? ''),
  }))
  service
    .uninstallSoftware({
      execute_type: 0,
      uninstall_list,
      uninstall_type: data.uninstallType,
      soft_name: props.softwareName,
    })
    .then(() => {
      ElMessage.success(t('genuineSoftwareUsage.uninstallSuccessTerminals', { count: uninstall_list.length }))
      service.cancelSelectAll()
      memUi.selectAll = false
      void refreshList()
    })
    .catch(() => {
      ElMessage.error(t('softwareUsage.uninstallFailTerminals', { count: uninstall_list.length }))
      service.cancelSelectAll()
    })
}

function uninstall () {
  data.uninstallDialogVisible = false
  if (memUi.selectAll) {
    uninstallSelectedClient()
  } else {
    deleteSoftware()
  }
}

function download (type: 0 | 1) {
  service.download(type, { ...form }, t('genuineSoftwareUsage.exportPrefixSoftwareDetail') + t('softwareUsage.installedSoftwareTitle', { name: props.softwareName }))
}

watch(
  () => [props.softwareId, props.softwareName, props.groupId, props.dateRange],
  () => {
    form.soft_id = props.softwareId
    form.soft_name = props.softwareName
    form.group_id = props.groupId
    const tr = rangeToStartEnd()
    form.start_time = tr.start_time
    form.end_time = tr.end_time
    form.page = 1
    void nextTick(() => void refreshList())
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      modelValue: form,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
      "table-opt": tableOpt.value,
      api: getListApi,
      "page-option": pageOption,
      "has-permission": hasPermission.value,
      "first-loading": true
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !hasPermission.value,
          "show-search": true,
          "search-placeholder": _ctx.$t('genuineSoftwareUsage.searchPlaceholderInstallDetail'),
          "popover-threshold": 0,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              disabled: (!(memUi.selectCount > 0) && !memUi.selectAll) || !hasPermission.value,
              type: "primary",
              size: "small",
              onClick: showUninstallDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstall')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(ExportDropdown, {
              "has-permission": hasPermission.value,
              onExport: download
            }, null, 8, ["has-permission"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionPrefix')) + " ", 1),
            _createElementVNode("a", {
              onClick: getListByMemory,
              class: _normalizeClass(!form.useMemory ? 'req-primary' : 'req-default')
            }, _toDisplayString(memUi.selectCount), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionTerminalSuffix')), 1)
          ]),
          (memUi.pageSelectCount < visibleRowCount.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                disabled: memUi.selectAll,
                class: "pagination-select-btn",
                type: "text",
                onClick: togglePageSelect
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectPageAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                disabled: memUi.selectAll,
                class: "pagination-select-btn",
                type: "text",
                onClick: togglePageSelect
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectPageInvert')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: memUi.selectAll,
            onClick: selectAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.selectAllInGroup')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: !memUi.selectCount,
            onClick: selectCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.clearSelection')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      __sel: _withCtx((slotProps) => [
        _createVNode(_component_el_checkbox, {
          "model-value": selRow(slotProps).$selected,
          disabled: memUi.selectAll,
          onChange: ($event: any) => (onRowCheck(selRow(slotProps)))
        }, null, 8, ["model-value", "disabled", "onChange"])
      ]),
      _: 1
    }, 8, ["modelValue", "table-opt", "has-permission"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.$t('genuineSoftwareUsage.uninstallDialogTitle'),
      modelValue: data.uninstallDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.uninstallDialogVisible) = $event)),
      width: "30%",
      "before-close": resetRadio,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: uninstall
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.uninstallType) = $event)),
          label: 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeNotify')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.uninstallType) = $event)),
          label: 1
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeSilent')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})